export const GlobalVariable = {
  SITE_NAME: 'TMS Admin',
  tokenKey: 'Smartpath_token' ,
  languageType :1 ,
};   



export enum PermissionGroupName {
  Marketing = "Marketing",
  Sales = "Sales",
  Demo = "Demo",
  Students = "Students",
  Instructors = "Instructors",
  TMS = "TMS",
  DOTCompliance = "DOT Compliance",
  HumanResources = "Human Resources",
  Accounting = "Accounting",
  BizPartners = "Biz Partners",
  Candidates = "Candidates",
  Recordings = "Recordings",
}

export const PermissionUrls = new Map<string, string>([
  [PermissionGroupName.Marketing, "/marketing"],
  [PermissionGroupName.Sales, "/pipeline/sales"],
  [PermissionGroupName.Demo, "/demo"],
  [PermissionGroupName.Students, "/students/newstudent"],
  [PermissionGroupName.HumanResources, "/hr"],
  [PermissionGroupName.Instructors, "/instructors"],
  [PermissionGroupName.TMS, "/tms"],
  [PermissionGroupName.DOTCompliance, "/dot-compliance"],
  [PermissionGroupName.Accounting, "/accounting/ar"],
  [PermissionGroupName.BizPartners, "/bizpartners/newbizpartners"],
  [PermissionGroupName.Candidates, "/candidate/newcandidate"],
  [PermissionGroupName.Recordings, "/recordings"],
]);

export const permissionGroupsTMS = [
     {
      name: "Dashboard",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "IFTA",
      subPermissions: ["Create IFTA", "View IFTA", "Update IFTA", "Download Report"],
  },
 
  {
      name: "Account",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Loads",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Dispatched",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  
  {
      name: "Assets",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Partner",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Report",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Carriers",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Settings",
      subPermissions: ["Create ", "Read ", "Update ", "Delete "],
  },
  {
      name: "Business Book",
      subPermissions: ["View Broker ", "View Vendor ","View Shipper" ],
  },
  
];

export let DEMO_MEETING_COMMON_LINK="https://awahe.daily.co/1LE2ttkTM0QaOki6oIXH";
